// frontend/src/pages/PrivacyPage.js
import React from 'react';

export default function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-6">Last updated: December 8, 2025</p>

      <p className="text-gray-700 mb-4">
        ScalableDeploy is a technology services brand of OL Trading LLC
        (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;). This Privacy Policy explains how we
        collect, use, and protect information in connection with our website
        scalabledeploy.com and our AWS/AI consulting and engineering services
        (the &quot;Services&quot;).
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Information we collect</h2>
      <p className="text-gray-700 mb-2">
        We collect information in a few basic ways:
      </p>
      <ul className="list-disc pl-5 text-gray-700 space-y-1 mb-4 text-sm">
        <li>
          <strong>Information you provide:</strong> such as your name, email address,
          company name, and any project details you share when you contact us,
          request a pilot, or otherwise communicate with us.
        </li>
        <li>
          <strong>Payment information:</strong> when you pay for a service, payment
          details are processed by our payment processor (Stripe). We do not store
          full credit card numbers on our own servers.
        </li>
        <li>
          <strong>Usage information:</strong> basic technical data such as IP address,
          browser type, and pages visited, which may be collected via server logs or
          analytics tools to help us understand how our site and demos are used.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. How we use information</h2>
      <p className="text-gray-700 mb-2">
        We use the information we collect to:
      </p>
      <ul className="list-disc pl-5 text-gray-700 space-y-1 mb-4 text-sm">
        <li>Provide and maintain our Services and demos.</li>
        <li>Respond to inquiries, proposals, and support requests.</li>
        <li>Process payments and send relevant billing communications.</li>
        <li>Improve our offerings, documentation, and site experience.</li>
        <li>Communicate about updates, new features, or important notices.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Cookies and analytics</h2>
      <p className="text-gray-700 mb-4 text-sm">
        We may use cookies or similar technologies to remember preferences and
        understand how visitors use the site or demos. You can typically adjust
        your browser settings to refuse cookies, although some features may not
        function correctly if you do so.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Sharing of information</h2>
      <p className="text-gray-700 mb-2 text-sm">
        We do not sell your personal information. We may share limited information with:
      </p>
      <ul className="list-disc pl-5 text-gray-700 space-y-1 mb-4 text-sm">
        <li>
          <strong>Service providers:</strong> such as payment processors, hosting providers,
          and tools we use to operate and improve our Services.
        </li>
        <li>
          <strong>Legal or compliance reasons:</strong> if required by law, regulation,
          or to protect our rights or the rights of others.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Data retention</h2>
      <p className="text-gray-700 mb-4 text-sm">
        We retain information for as long as reasonably necessary to provide the
        Services, meet legal or tax obligations, resolve disputes, and enforce
        our agreements. Where possible, we may anonymize or aggregate data for
        longer-term analytics.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Your choices</h2>
      <p className="text-gray-700 mb-4 text-sm">
        You can contact us to request updates or corrections to your information,
        or to ask questions about how your data is used. If you receive email
        communications from us that you no longer wish to receive, you can
        request to opt out.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Third-party links</h2>
      <p className="text-gray-700 mb-4 text-sm">
        Our site or demos may link to third-party websites or services. We are
        not responsible for the privacy practices or content of those third
        parties, and we encourage you to review their policies separately.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Changes to this policy</h2>
      <p className="text-gray-700 mb-4 text-sm">
        We may update this Privacy Policy from time to time. When we do, we will
        revise the &quot;Last updated&quot; date at the top of this page. Your
        continued use of the site or Services after any changes become effective
        constitutes your acceptance of the updated policy.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Contact</h2>
      <p className="text-gray-700 mb-2 text-sm">
        If you have any questions about this Privacy Policy or how we handle
        data, you can contact us at:
      </p>
      <p className="text-gray-700 text-sm">
        Email: <a href="mailto:hello@scalabledeploy.com" className="underline">
          hello@scalabledeploy.com
        </a>
      </p>
    </div>
  );
}
